import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  h1 {
    font-size: ${props => props.theme.texts.titleL.fontSize};
    font-family: ${props => props.theme.texts.titleL.fontFamily};
    line-height: ${props => props.theme.texts.titleL.lineHeight};
    letter-spacing: ${props => props.theme.texts.titleL.letterSpacing};
    color: ${props => props.theme.colors.black};
    margin: 0;
    margin-bottom: ${props => props.theme.whiteLabel.spacing.sp16};
    text-align: center;
  }
`

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${props => props.theme.whiteLabel.spacing.sp8};
  color: ${props => props.theme.colors.green.tone500};

  ${props =>
    (props.paymentPending || props.orderCancelled) &&
    css`
      svg {
        color: ${props => props.theme.colors.orange.tone500};
      }
    `}
`
